export enum ProductType {
    Unknown = 0,
    HourlyRate = 1,
    FixedRate = 2,
    MultiDay = 3
}
